import { useQuery } from "@tanstack/react-query";
import {
  PositionSearchParams,
  positionSearch,
} from "common/api/unos_rad/unos_position";
import { QUERY_KEYS } from "constant/react_query";

export const useUnosPositionSearch = (searchParams?: PositionSearchParams) => {
  const { data: position } = useQuery(
    [QUERY_KEYS.UNOS_VIDEO_SEARCH, searchParams],
    async () => {
      const result = await positionSearch(searchParams);
      return result;
    },
    { staleTime: Infinity }
  );
  const result =
    typeof position !== "undefined" && position !== "" ? position : null;
  return result;
};
